import { resourceReservationRequestZodSchema } from "@@/shared/acquire/resources/resource-reservation-request";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { orderGroupIdZodSchema } from "@@/shared/order-groups/order-group-id";
import { payRequestRecipientZodSchema } from "@@/shared/pay-requests/pay-request-recipient";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { translatableZodSchema } from "@@/shared/translations/translation";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import { orderChangeItemZodSchema } from "../order-changes/order-change-item";
import { orderIdZodSchema } from "../order-id";

const orderChangeCommandZodObject = z.discriminatedUnion("payment", [
    z.object({
        _id: idZodSchema,
        _createdAt: isoAndUnixZodSchema,
        _type: z.literal("ORDER_CHANGE_COMMAND"),
        payment: z.enum(["ON_PREMISE_PAID", "ON_PREMISE_PAY_LATER"]),
        orderGroupId: orderGroupIdZodSchema,
        orderId: orderIdZodSchema,
        providerId: providerIdZodSchema,
        reason: translatableZodSchema,
        changes: z.array(orderChangeItemZodSchema).min(1),
        newReservations: z.array(resourceReservationRequestZodSchema), //resourceReservationRequestZodSchema),
    }),
    z.object({
        _id: idZodSchema,
        _createdAt: isoAndUnixZodSchema,
        _type: z.literal("ORDER_CHANGE_COMMAND"),
        payment: z.literal("PAY_REQUEST"),
        orderGroupId: orderGroupIdZodSchema,
        orderId: orderIdZodSchema,
        providerId: providerIdZodSchema,
        reason: translatableZodSchema,
        changes: z.array(orderChangeItemZodSchema).min(1),
        newReservations: z.array(resourceReservationRequestZodSchema), //resourceReservationRequestZodSchema),
        payRequestRecipients: z.array(payRequestRecipientZodSchema),
    }),
    z.object({
        _id: idZodSchema,
        _createdAt: isoAndUnixZodSchema,
        _type: z.literal("ORDER_CHANGE_COMMAND"),
        payment: z.enum(["REFUND", "NO_CHANGE"]),
        orderGroupId: orderGroupIdZodSchema,
        orderId: orderIdZodSchema,
        providerId: providerIdZodSchema,
        reason: translatableZodSchema,
        changes: z.array(orderChangeItemZodSchema).min(1),
        newReservations: z.array(resourceReservationRequestZodSchema), //resourceReservationRequestZodSchema),
    }),
]);

type OrderChangeCommand = z.infer<typeof orderChangeCommandZodObject>;

type FactoryParams = Except<OrderChangeCommand, "_id" | "_type" | "_createdAt">;
const orderChangeCommandFactory = (params: FactoryParams) => {
    const command: OrderChangeCommand = {
        ...params,
        _id: generateId({ prefix: "order_CHANGE_command__" }),
        _type: "ORDER_CHANGE_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return command;
};

export { orderChangeCommandFactory, orderChangeCommandZodObject };
export type {
    OrderChangeCommand,
    FactoryParams as OrderChangeCommandFactoryParams,
};
